<div class="min-h-screen bg-gray-100 dark:bg-gray-900">
  <!-- Global Toast for interceptor messages -->
  <p-toast />

  <!-- Header -->
  <app-header />

  <!-- Impersonation Banner (shown when impersonating) -->
  <app-impersonation-banner />

  <div class="flex">
    <!-- Sidebar -->
    <app-sidebar />

    <!-- Main Content -->
    <main
      class="flex-1 transition-all duration-300"
      [class.lg:ml-64]="!sidebarStore.isCollapsed()"
      [class.lg:ml-16]="sidebarStore.isCollapsed()"
    >
      <div class="p-6">
        <router-outlet />
      </div>
    </main>
  </div>

  <!-- Mobile sidebar overlay -->
  @if (sidebarStore.isMobileOpen()) {
    <div
      class="fixed inset-0 bg-black bg-opacity-50 z-30 lg:hidden"
      role="button"
      tabindex="0"
      aria-label="Close sidebar"
      (click)="sidebarStore.closeMobile()"
      (keydown.enter)="sidebarStore.closeMobile()"
      (keydown.escape)="sidebarStore.closeMobile()"
    ></div>
  }
</div>
